import Vue from 'vue'
import Vuex from 'vuex'
import data from './data'
import { forEach } from 'lodash'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    _fileUploads: {},
    _user: {},
    _users: {},
    _userLocation: {},
    _userDevice: {},
    _appBarTitle: '',
    _appBarTabs: [],
    _calculators: {},
    _products: {},
    _loader: false,
    _drawer: false,
    _badgeTotals: {},
    _pushToken: false,
    _vapidKeyUsed: false,
    _fingerprint: null,
    _clientPathInit: false,
    _messagingEnabled: {},
    _assistanceTypes: {},
    _announcementActive: false,
    _reportIsAdmin: false,
    _reportAdminToken: null,
  },
  mutations: {
    set_user (state, _user) {
      state._user = _user
    },
    set_users (state, _users) {
      state._users = _users
    },
    set_userLocation (state, _userLocation) {
      state._userLocation = _userLocation
    },
    set_userDevice (state, _userDevice) {
      state._userDevice = _userDevice
    },
    set_appBarTitle (state, _appBarTitle) {
      state._appBarTitle = _appBarTitle
    },
    set_appBarTabs (state, _appBarTabs) {
      state._appBarTabs = _appBarTabs
    },
    set_calculators (state, _calculators) {
      state._calculators = _calculators
    },
    set_products (state, _products) {
      state._products = _products
    },
    set_loader (state, _loader) {
      state._loader = _loader
    },
    set_fileUploads (state, fileUpload) {
      Vue.set(state._fileUploads, fileUpload.id, fileUpload)
    },
    set_drawer (state, _drawer) {
      state._drawer = _drawer
    },
    set_badgeTotals (state, _badgeTotals) {
      state._badgeTotals = _badgeTotals
    },
    set_pushToken (state, _pushToken) {
      state._pushToken = _pushToken
    },
    set_vapidKeyUsed (state, _vapidKeyUsed) {
      state._vapidKeyUsed = _vapidKeyUsed
    },
    set_fingerprint (state, _fingerprint) {
      state._fingerprint = _fingerprint
    },
    set_clientPathInit (state, _clientPathInit) {
      state._clientPathInit = _clientPathInit
    },
    set_messagingEnabled (state, _messagingEnabled) {
      state._messagingEnabled = _messagingEnabled
    },
    set_assistanceTypes (state, _assistanceTypes) {
      state._assistanceTypes = _assistanceTypes
    },
    set_announcementActive(state, _announcementActive) {
      state._announcementActive = _announcementActive
    },
    set_reportIsAdmin(state, _reportIsAdmin) {
      state._reportIsAdmin = _reportIsAdmin
    },
    set_reportAdminToken(state, _reportAdminToken) {
      state._reportAdminToken = _reportAdminToken
    },
  },
  getters: {
    _pageLayout: () => {
      // return { xs12: true, md10: true, lg8: true, xl6: true, 'pa-0': true }
      return { xs12: true, md10: true, lg8: true, xl6: true, 'mx-auto': true}
    },
    _fileUploads: state => {
      return state._fileUploads
    },
    _inputTypes: () => {
      return data.inputTypes
    },
    _inputTypesItemsArr: () => {
      var a = []
      forEach(data.inputTypes, (input, key) => {
        a.push({ text: input.name, value: key, icon: input.icon })
      })
      return a
    },
    _user: state => {
      return state._user
    },
    _userInfo: state => {
      return state._users[state._user.uid] || {}
    },
    _users: state => {
      return state._users
    },
    _userLocation: state => {
      return state._userLocation
    },
    _userDevice: state => {
      return state._userDevice
    },
    _appBarTitle: state => {
      return state._appBarTitle
    },
    _appBarTabs: state => {
      return state._appBarTabs
    },
    _calculators: state => {
      return state._calculators
    },
    _products: state => {
      return state._products
    },
    _loader: state => {
      return state._loader
    },
    _drawer: state => {
      return state._drawer
    },
    _badgeTotals: state => {
      return state._badgeTotals
    },
    _pushToken: state => {
      return state._pushToken
    },
    _vapidKeyUsed: state => {
      return state._vapidKeyUsed
    },
    _fingerprint: state => {
      return state._fingerprint
    },
    _clientPathInit: state => {
      return state._clientPathInit
    },
    _messagingEnabled: state => {
      return state._messagingEnabled
    },
    _assistanceTypes: state => {
      return state._assistanceTypes
    },
    _announcementActive: state => {
      return state._announcementActive
    },
    _reportIsAdmin: state => {
      return state._reportIsAdmin
    },
    _reportAdminToken: state => {
      return state._reportAdminToken
    },
  },
  actions: {

  }
})
